import { BrowserModule } from '@angular/platform-browser';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header/header.component';
import { MainContentComponent } from './main-content/main-content.component';
import { HomeComponent } from './home/home.component';
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { TreeviewModule } from 'ngx-treeview';
import { CartComponent } from './cart/cart.component';
import { ProductsComponent } from './home/products/products.component';
import { LoginComponent } from './login/login.component';
import { CustomerComponent } from './customer/customer.component';
import { CheckoutComponent } from './checkout/checkout.component';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SignupComponent } from './signup/signup.component';
import { ProductdetailComponent } from './productdetail/productdetail.component';
import { PhotoSwipeComponent } from './productdetail/photo-swipe/photo-swipe.component';
import { CategoryComponent } from './category/category.component';
import { ContactComponent } from './contact/contact.component';
import { CatCarouselComponent } from './cat-carousel/cat-carousel.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    MainContentComponent,
    HomeComponent,
    CartComponent,
    ProductsComponent,
    LoginComponent,
    SignupComponent,
    CustomerComponent,
    ProductdetailComponent,
    CheckoutComponent,
    PhotoSwipeComponent,
    CategoryComponent,
    ContactComponent,
    CatCarouselComponent
  ],
  imports: [
    BrowserModule,

    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    HttpClientModule,
    AppRoutingModule,
    NgbModule,
    InfiniteScrollModule,
    FormsModule,
    ReactiveFormsModule,
    TreeviewModule.forRoot()
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
